var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleStepsIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5043_5210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5043_5210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.125 50C50.5208 50 48.3073 49.0885 46.4844 47.2656C44.6615 45.4427 43.75 43.2292 43.75 40.625C43.75 38.0208 44.6615 35.8073 46.4844 33.9844C48.3073 32.1615 50.5208 31.25 53.125 31.25C55.7292 31.25 57.9427 32.1615 59.7656 33.9844C61.5885 35.8073 62.5 38.0208 62.5 40.625C62.5 43.2292 61.5885 45.4427 59.7656 47.2656C57.9427 49.0885 55.7292 50 53.125 50ZM34.375 71.875V62.8125C34.375 61.7188 34.6354 60.6901 35.1562 59.7266C35.6771 58.763 36.4062 57.9948 37.3438 57.4219C39.0104 56.4323 40.7682 55.612 42.6172 54.9609C44.4661 54.3099 46.3542 53.8281 48.2812 53.5156L53.125 59.375L57.9688 53.5156C59.8958 53.8281 61.7708 54.3099 63.5938 54.9609C65.4167 55.612 67.1615 56.4323 68.8281 57.4219C69.7656 57.9948 70.5078 58.763 71.0547 59.7266C71.6016 60.6901 71.875 61.7188 71.875 62.8125V71.875H34.375ZM28.125 62.8125V65.625H15.625C13.9062 65.625 12.4349 65.013 11.2109 63.7891C9.98698 62.5651 9.375 61.0938 9.375 59.375V15.625C9.375 13.9062 9.98698 12.4349 11.2109 11.2109C12.4349 9.98698 13.9062 9.375 15.625 9.375H59.375C61.0938 9.375 62.5651 9.98698 63.7891 11.2109C65.013 12.4349 65.625 13.9062 65.625 15.625V31.25C64.0104 29.2188 62.1875 27.6693 60.1562 26.6016C58.125 25.5339 55.7812 25 53.125 25V21.875H21.875V28.125H43.75C42.7083 28.9583 41.7708 29.8958 40.9375 30.9375C40.1042 31.9792 39.401 33.125 38.8281 34.375H21.875V40.625H37.5C37.5 41.7188 37.6172 42.7865 37.8516 43.8281C38.0859 44.8698 38.4115 45.8854 38.8281 46.875H21.875V53.125H32.6562C31.25 54.3229 30.1432 55.7682 29.3359 57.4609C28.5286 59.1536 28.125 60.9375 28.125 62.8125Z",
    fill: "#FFCF00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleStepsIcon3);
export default __webpack_public_path__ + "static/media/SimpleStepsIcon3.2e58008766011ac03a5f38be480e0911.svg";
export { ForwardRef as ReactComponent };